if ( typeof ProductQuantity !== 'function' ) {

	class ProductQuantity extends HTMLElement {

		constructor(){

			super();

			const qty = this.querySelector('.qty-selector'),
						qtyMinus = this.querySelector('.qty-minus'),
						qtyPlus = this.querySelector('.qty-plus'),
						qtyMin = qty.getAttribute('min') ? parseInt(qty.getAttribute('min')) : 1,
						qtyMax = qty.getAttribute('max') ? parseInt(qty.getAttribute('max')) : 999;
						const step = () => parseFloat(qty.getAttribute('step')) || 1;

			
			if ( parseInt(qty.value) - step() < qtyMin ) {
				qtyMinus.classList.add('disabled');
			}

			if ( parseInt(qty.value) + step() > qtyMax ) {
				qtyPlus.classList.add('disabled');
			}

			qty.addEventListener('change', (e)=>{
				const currentQty = parseInt(qty.value);
		
				if ( parseInt(qty.value) - step() < qtyMin ) {
					qtyMinus.classList.add('disabled');
				} else {
					qtyMinus.classList.remove('disabled');
				}

				if ( parseInt(qty.value) + step() > qtyMax ) {
					qtyPlus.classList.add('disabled');
				} else {
					qtyPlus.classList.remove('disabled');
				}
			});

			qtyMinus.addEventListener('click', (e)=>{
				e.preventDefault();
				if ( ! qtyMinus.classList.contains('disabled') ) {
					const currentQty = parseInt(qty.value);
					const n = step();

					if ( currentQty - n >= qtyMin ) {
						qty.value = currentQty - n;
						qty.dispatchEvent(new Event('input', { bubbles: true }));
						qtyPlus.classList.remove('disabled');
					}
				
					if ( currentQty - n <= qtyMin ) {
						qtyMinus.classList.add('disabled');
					}
				}
			});

			qtyPlus.addEventListener('click', (e)=>{
				e.preventDefault();
				if ( ! qtyPlus.classList.contains('disabled') ) {
					const currentQty = parseInt(qty.value);
					const n = step();
					
					if ( currentQty + n <= qtyMax ) {
						qty.value = currentQty + n;
						qty.dispatchEvent(new Event('input', { bubbles: true }));
						qtyMinus.classList.remove('disabled');
					}
					
					if ( currentQty + n >= qtyMax ) {
						qtyPlus.classList.add('disabled');
					}
				}
			});

		}
		
	}


  if ( typeof customElements.get('product-quantity') == 'undefined' ) {
    customElements.define('product-quantity', ProductQuantity);
	}

}